import { render, staticRenderFns } from "./Modification.vue?vue&type=template&id=820270aa&scoped=true&"
import script from "./Modification.vue?vue&type=script&lang=js&"
export * from "./Modification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820270aa",
  null
  
)

export default component.exports